<tt-page *ngIf="!!location">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editPositionInfo"></ng-container>
            <ng-container *ngTemplateOutlet="positionInfo"></ng-container>
            <ng-container *ngTemplateOutlet="editButtons"></ng-container>
            <ng-container *ngTemplateOutlet="directionButtons"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="editPositionInfo"></ng-container>
                <ng-container *ngTemplateOutlet="editButtons"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="positionInfo"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="directionButtons"></ng-container>
            </tt-card>
        </div>
    </div>
</tt-page>

<ng-template #editPositionInfo>
    <ng-container *ngIf="!!location">
        <tt-input ttLabel="gisposition_name" [(ttModel)]="location.gisposition_name" ttRequired></tt-input>
        <tt-editor ttLabel="gisposition_note" [(ttModel)]="location.gisposition_note" [(ttProcessing)]="readyGisPositionNote"></tt-editor>
        <tt-datetime ttLabel="pos_datetime" [(ttModel)]="location.pos_datetime"></tt-datetime>
        <tt-textarea ttLabel="source_note" [(ttModel)]="location.source_note"></tt-textarea>
    </ng-container>
</ng-template>

<ng-template #positionInfo>
    <ng-container *ngIf="!!location">
        <tt-input ttLabel="lat" [ttModel]="location.lat" ttReadonly></tt-input>
        <tt-input ttLabel="lng" [ttModel]="location.lng" ttReadonly></tt-input>
        <tt-input-number ttLabel="position_accuracy_m" [ttModel]="location.position_accuracy_m" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="altitude_m" [ttModel]="location.altitude_m" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="altitude_accuracy_m" [ttModel]="location.altitude_accuracy_m" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="location.reg_by_portal_user_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #directionButtons>
    <ng-container *ngIf="!!location">
        <tt-button-goto [ttText]="'gisposition_pictures'" [ttGoto]="'pictures'" [ttGotoParms]="{ argtype: 'gisposition_keyno', argvalue: location.gisposition_keyno }"></tt-button-goto>
        <tt-button ttText="gisposition_googlemap" (ttClick)="openGoogleMaps()" ttIcon="fa fa-window-restore"></tt-button>
        <tt-button ttText="gisposition_finn" (ttClick)="openFinn()" ttIcon="fa fa-window-restore"></tt-button>
    </ng-container>
</ng-template>

<ng-template #editButtons>
    <ng-container *ngIf="!!location">
        <tt-button-save ttText="gisposition_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="gisPositionKeyno !== '0'" ttText="gisposition_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </ng-container>
</ng-template>
